import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { FilterDTO, PagedResultDTOOfTagMasterDTO, SortDirection, TagMasterClient } from 'src/app/base/models/models.swagger.generated';
import { ClientService } from 'src/app/base/services/client/client.service';
import { ToastService } from 'src/app/base/services/toast.service';
import { DATE_HELPER_DEFAULT_TIME_ZONE } from 'src/app/base/shared/date-helper';
import { FilterUtil } from 'src/app/base/shared/filter-util';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})

export class TagMasterService extends ShowInactiveService implements IAdaptorService {
  constructor(private tagMasterClient: TagMasterClient,
    private clientService: ClientService,
    private toastService: ToastService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    if (this.clientService.selectedClient == null) {
      return of(new PagedResultDTOOfTagMasterDTO({ items: [], totalNumberOfItems: 0 }));
    }
    FilterUtil.correctDateTimeFilters(filters, 'AssignedOn', DATE_HELPER_DEFAULT_TIME_ZONE);
    return this.tagMasterClient.searchTagMasters(this.clientService.selectedClient.id, filters, skip, take, sortBy, sortDirection, false);
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    return this.deleteRecords([id]);
  }

  public deleteRecords(id: number[]): Observable<any> {
    return this.tagMasterClient.deleteTagMasters(id).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.tag-master.messages.delete-title',
          'i18n.domain.tag-master.messages.delete-success-message'
        );
      }),
      catchError(error => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }
}
